import CommonHeaderContainer from '../../../containers/common/commonHeader/commonHeaderContainer';

export default function CommonHeader() {
  return <CommonHeaderContainer />;
}
